import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ServicoBio, BioLink } from '../services/servico-bio.service';
import { AutorizacaoService } from '../../services/autorizacao.service';
import { NotificationService } from '@progress/kendo-angular-notification';

@Component({
  selector: 'app-bio-links',
  templateUrl: './bio-links.component.html',
  styleUrls: ['./bio-links.component.scss']
})
export class BioLinksComponent implements OnInit {

  links: BioLink[] = [];
  carregando = true;
  salvando = false;
  idBioPagina: number;
  slugBioPagina: string;
  corPrimaria: string = '#2e7d32';
  modoPreview: 'mobile' | 'desktop' = 'mobile';
  urlPreview: SafeResourceUrl;
  timestampPreview = Date.now();
  modalDeletar = false;
  linkApagar: BioLink = null;

  exibirDialogPlataformas = false;
  plataformasSelecionadas = new Set<string>();
  linkExpandido: number | string = null;
  erroValidacaoLink: string = null;
  private _tempIdCounter = 0;

  tiposDeLink: { valor: string; label: string; icone: string; cor: string; logo?: string }[] = [
    { valor: 'cardapio', label: 'Meu Cardapio', icone: '', cor: '#E53935', logo: 'assets/fidelidade/promokit-preto.png' },
    { valor: 'whatsapp', label: 'WhatsApp', icone: 'fab fa-whatsapp', cor: '#25D366' },
    { valor: 'instagram', label: 'Instagram', icone: 'fab fa-instagram', cor: '#E1306C' },
    { valor: 'ifood', label: 'iFood', icone: '', cor: '#EA1D2C', logo: 'assets/icons/logo-ifood.png' },
    { valor: 'telefone', label: 'Telefone', icone: 'fas fa-phone-alt', cor: '#1976D2' },
    { valor: 'localizacao', label: 'Localizacao', icone: 'fas fa-map-marker-alt', cor: '#F57C00' },
    { valor: 'reserva', label: 'Reserva', icone: 'fas fa-calendar-check', cor: '#7B1FA2' },
    { valor: '99food', label: '99Food', icone: '', cor: '#FFCC00', logo: 'assets/icons/logo-99food.png' },
    { valor: 'aiqfome', label: 'Aiqfome', icone: '', cor: '#7D0DC3', logo: 'assets/icons/logo-aiqfome.png' },
    { valor: 'site', label: 'Site / Outro', icone: 'fas fa-globe', cor: '#455A64' }
  ];

  constructor(
    private servicoBio: ServicoBio,
    private autorizacaoService: AutorizacaoService,
    private notificationService: NotificationService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.autorizacaoService.fetchUser().subscribe(usuario => {
      if (!usuario?.empresa?.id) {
        this.carregando = false;
        this.mostrarNotificacao('Nao foi possivel carregar os dados da empresa.', 'error');
        return;
      }

      this.servicoBio.obterBioPagina(usuario.empresa.id).then((data: any) => {
        if (data && data.id) {
          this.idBioPagina = data.id;
          this.slugBioPagina = data.slug;
          this.corPrimaria = data.corPrimaria || '#2e7d32';
          this.atualizarUrlPreview();
          this.carregarLinks();
        } else {
          this.carregando = false;
        }
      }).catch(() => {
        this.carregando = false;
      });
    });
  }

  carregarLinks() {
    this.carregando = true;
    this.servicoBio.obterLinks(this.idBioPagina).then((data: BioLink[]) => {
      this.links = data || [];
      this.carregando = false;
    }).catch(() => {
      this.carregando = false;
    });
  }

  novoLink() {
    this.plataformasSelecionadas.clear();
    this.exibirDialogPlataformas = true;
  }

  togglePlataforma(tipo: string) {
    if (this.plataformasSelecionadas.has(tipo)) {
      this.plataformasSelecionadas.delete(tipo);
    } else {
      this.plataformasSelecionadas.add(tipo);
    }
  }

  confirmarPlataformas() {
    let primeiroTempId: string = null;
    this.plataformasSelecionadas.forEach(tipo => {
      const tipoInfo = this.tiposDeLink.find(t => t.valor === tipo);
      const tempId = '_new_' + (++this._tempIdCounter);
      const novoLink: any = {
        id: null,
        _tempId: tempId,
        idBioPagina: this.idBioPagina,
        tipo,
        titulo: tipoInfo ? tipoInfo.label : tipo,
        subtitulo: '',
        icone: tipoInfo ? tipoInfo.icone : 'fas fa-link',
        urlIconeCustomizado: '',
        url: '',
        etiqueta: '',
        ordem: this.links.length,
        ativo: true
      };
      if (tipo === 'whatsapp') {
        novoLink.url = 'https://wa.me/55';
      } else if (tipo === 'telefone') {
        novoLink.url = 'tel:+55';
      } else if (tipo === '99food') {
        novoLink.url = 'https://www.99food.com/';
      } else if (tipo === 'aiqfome') {
        novoLink.url = 'https://aiqfome.com/';
      }
      if (!primeiroTempId) primeiroTempId = tempId;
      this.links.push(novoLink);
    });
    this.exibirDialogPlataformas = false;
    if (primeiroTempId) {
      this.linkExpandido = primeiroTempId;
    }
  }

  editarLink(link: any, index: number) {
    this.linkExpandido = link.id || link._tempId || index;
  }

  isGibberish(text: string): boolean {
    const limpo = (text || '').replace(/\s/g, '');
    const repetido = /^(.)\1{3,}$/i;
    const prefixos = /^(abc|123|test|xxx|qwer|asdf|zxcv)/i;
    const somenteConsoantes = /^[bcdfghjklmnpqrstvwxyz]{4,}$/i;
    return repetido.test(limpo) || prefixos.test(limpo) || somenteConsoantes.test(limpo);
  }

  salvarLinkInline(link: BioLink, index: number) {
    this.erroValidacaoLink = null;
    if (!link.titulo) {
      this.erroValidacaoLink = 'Informe o titulo do link.';
      return;
    }
    if (this.isGibberish(link.titulo)) {
      this.erroValidacaoLink = 'O titulo do link parece invalido.';
      return;
    }
    if (link.subtitulo && link.subtitulo.trim() && this.isGibberish(link.subtitulo)) {
      this.erroValidacaoLink = 'O subtitulo do link parece invalido.';
      return;
    }
    if (link.etiqueta && link.etiqueta.trim() && this.isGibberish(link.etiqueta)) {
      this.erroValidacaoLink = 'A etiqueta do link parece invalida.';
      return;
    }
    if (!link.url && link.tipo !== 'telefone') {
      this.erroValidacaoLink = 'Informe a URL do link.';
      return;
    }

    this.salvando = true;
    const operacao = link.id
      ? this.servicoBio.atualizarLink(link.id, link)
      : this.servicoBio.salvarLink(link);

    operacao.then((resultado: any) => {
      this.salvando = false;
      if (!link.id && resultado && resultado.id) {
        this.links[index] = { ...link, id: resultado.id };
      }
      this.linkExpandido = null;
      this.recarregarPreview();
      this.mostrarNotificacao('Link salvo com sucesso!', 'success');
    }).catch(() => {
      this.salvando = false;
      this.mostrarNotificacao('Erro ao salvar link. Tente novamente.', 'error');
    });
  }

  cancelarEdicaoInline(link: BioLink, index: number) {
    this.erroValidacaoLink = null;
    if (!link.id) {
      this.links.splice(index, 1);
    }
    this.linkExpandido = null;
  }

  confirmarExclusao(link: BioLink) {
    this.linkApagar = link;
    this.modalDeletar = true;
  }

  fecharModalDeletar(confirmou: string) {
    if (confirmou === 'sim') {
      if (this.linkApagar.id) {
        this.servicoBio.excluirLink(this.linkApagar.id).then(() => {
          this.links = this.links.filter(l => l !== this.linkApagar);
          this.recarregarPreview();
          this.mostrarNotificacao('Link removido.', 'success');
          this.linkApagar = null;
          this.modalDeletar = false;
        });
        return;
      } else {
        this.links = this.links.filter(l => l !== this.linkApagar);
        this.mostrarNotificacao('Link removido.', 'success');
      }
    }
    this.linkApagar = null;
    this.modalDeletar = false;
  }

  onDrop(event: CdkDragDrop<BioLink[]>) {
    moveItemInArray(this.links, event.previousIndex, event.currentIndex);
    const ids = this.links.map(l => l.id).filter(id => id != null);
    this.servicoBio.reordenarLinks(this.idBioPagina, ids).catch(() => {
      this.carregarLinks();
    });
  }

  toggleAtivoLink(link: BioLink) {
    link.ativo = !link.ativo;
    if (link.id) {
      this.servicoBio.atualizarLink(link.id, link).catch(() => {
        link.ativo = !link.ativo;
      });
    }
  }

  obtenhaIconeDoTipo(tipo: string): string {
    const found = this.tiposDeLink.find(t => t.valor === tipo);
    return found ? found.icone : 'fas fa-link';
  }

  obtenhaCorDoTipo(tipo: string): string {
    const found = this.tiposDeLink.find(t => t.valor === tipo);
    return found ? found.cor : '#455A64';
  }

  obtenhaLabelDoTipo(tipo: string): string {
    const found = this.tiposDeLink.find(t => t.valor === tipo);
    return found ? found.label : tipo;
  }

  obtenhaLogoDoTipo(tipo: string): string {
    const found = this.tiposDeLink.find(t => t.valor === tipo);
    return found && found.logo ? found.logo : null;
  }

  placeholderUrl(tipo: string): string {
    if (tipo === 'whatsapp') return 'https://wa.me/5511999999999';
    if (tipo === 'telefone') return 'tel:+5511999999999';
    if (tipo === '99food') return 'https://www.99food.com/seu-restaurante';
    if (tipo === 'aiqfome') return 'https://aiqfome.com/seu-restaurante';
    return 'https://...';
  }

  atualizarUrlPreview() {
    if (!this.slugBioPagina) {
      this.urlPreview = null;
      return;
    }
    const url = window.location.origin + '/bio/' + this.slugBioPagina + '?preview=true&t=' + this.timestampPreview;
    this.urlPreview = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  recarregarPreview() {
    this.timestampPreview = Date.now();
    this.atualizarUrlPreview();
  }

  abrirEmNovaAba() {
    if (!this.slugBioPagina) return;
    window.open(window.location.origin + '/bio/' + this.slugBioPagina, '_blank');
  }

  private mostrarNotificacao(mensagem: string, tipo: 'success' | 'error') {
    this.notificationService.show({
      content: mensagem,
      type: { style: tipo, icon: true },
      position: { horizontal: 'right', vertical: 'top' },
      hideAfter: 3000
    });
  }
}
